import { Button } from 'antd';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import './index.scss'
import defiBanner from '../../../assets/images/cAsset DeFi COURSE.png'


const Course_1 = () => {

    return (
        <>
            <section>
                <div className="course_card_1">
                    <div className="cards-bg">
                        <div className="container">
                            <div className="cards-main-container">
                                <div className="cards-container">

                                    <div className="single-cards" key={1}>
                                        <div className="cards-img-container">
                                            <img src={defiBanner} alt="" />
                                            {/* <div className="circle"  ></div> */}
                                        </div>
                                        <div className="cards-module">
                                            <div className="btn-primary">COMDEX</div>
                                        </div>
                                        <div className="cards-title">DeFi & Synthetics</div>
                                        <div className="cards-description">
                                            This course will take you through the basics of blockchain, stablecoins, commodity markets, derivatives market and cAsset platform.
                                        </div>
                                        <div className="cards-button">
                                            <Link to="/courseModule"> <Button
                                                type="primary"
                                                className="btn-filled"
                                                size="small"
                                            >
                                                Explore &rarr;
                                            </Button></Link>
                                        </div>
                                    </div>

                                    {/* Card-2  */}


                                    <div className="single-cards coming-soon-single-card" key={2}>
                                        <div className="card-front-side">

                                            <div className="cards-img-container">
                                                <img src={defiBanner} alt="" />

                                                {/* <div className="circle" onClick={() => handleRouteChange(item)} ></div> */}
                                                {/* <div className="circle"  ></div> */}
                                            </div>
                                            <div className="cards-module">
                                                <div className="btn-primary">Module Name</div>
                                            </div>
                                            <div className="cards-title">Title</div>
                                            <div className="cards-description">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, vitae sequi! Laboriosam beatae, sapiente recusandae repellendus voluptas sunt doloremque voluptate!
                                            </div>
                                            <div className="cards-button">
                                                <Button
                                                    type="primary"
                                                    //   onClick={() => handleRouteChange(item)}
                                                    className="btn-filled"
                                                    size="small"
                                                >
                                                    Coming  Soon &rarr;
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="card-back-side">
                                            <h2>Coming Soon</h2>
                                        </div>
                                    </div>


                                    {/* card-3  */}
                                    <div className="single-cards coming-soon-single-card" key={3}>
                                        <div className="cards-img-container">
                                            {/* <div className="circle"  ></div> */}
                                            <img src={defiBanner} alt="" />
                                        </div>
                                        <div className="cards-module">
                                            <div className="btn-primary">Module Name</div>
                                        </div>
                                        <div className="cards-title">Title</div>
                                        <div className="cards-description">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, vitae sequi! Laboriosam beatae, sapiente recusandae repellendus voluptas sunt doloremque voluptate!
                                        </div>
                                        <div className="cards-button">
                                            <Button
                                                type="primary"
                                                className="btn-filled"
                                                size="small"
                                            >
                                                Coming Soon &rarr;
                                            </Button>
                                        </div>
                                        <div className="card-back-side">
                                            <h2>Coming Soon</h2>
                                        </div>
                                    </div>
                                    {/* </div> */}



                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>


        </>
    )
}

export default Course_1;